import {
  Document,
  PDFViewer,
  Page as PDFPage,
  StyleSheet,
  Text as PDFText,
  View as PDFView,
  Image as PDFImage,
  Font
} from '@react-pdf/renderer';

// Registering custom fonts
Font.register({
  family: 'Roboto',
  fonts: [{ src: '/Roboto-Bold.ttf', fontWeight: 'bold' }]
});

const styles = StyleSheet.create({
  page: {
    padding: 20
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0
  },
  text: {
    fontSize: 7,
    display: 'inline-block'
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },

  columnHeader: {
    width: '12%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center'
  },
  columnContent: {
    width: '12%',
    padding: 6,
    textAlign: 'center',
    alignItems: 'center'
  },
  largeColumnContent: {
    width: '200px',
    padding: 6,
    textAlign: 'center',
    alignItems: 'center'
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const COLORS = ['#f0f0f0', '#e0e0e0'];

const Page = ({ style, children, ...props }) => (
  <PDFPage style={{ ...styles.page, ...style }} {...props}>
    {children}
  </PDFPage>
);

const View = ({ style, children, ...props }) => (
  <PDFView style={{ ...style }} {...props}>
    {children}
  </PDFView>
);

const Text = ({ style, content, ...props }) => (
  <PDFText style={{ ...styles.text, ...style }} {...props}>
    {content}
  </PDFText>
);

export const RoomStatusReportPdf = ({ data }) => {
  console.log(data);
  const user = JSON.parse(localStorage.getItem('user'));
  let totalRecdCash = 0;

  // Function to format the date as needed (e.g., dd/mm/yyyy)
  function formatDate(dateString) {
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Room Status Report">
          <Page style={styles.page} size="A4" orientation="landscape">
            {/* Hospital Logo */}
            <PDFImage
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 1, marginRight: '10%' }}
            />

            <View style={styles.row}>
              <Text style={{ ...styles.columnHeader, width: '10%' }} content="Sr No." />
              <Text style={styles.columnHeader} content="Location" />
              <Text style={styles.columnHeader} content="Nurse Station" />
              <Text style={styles.columnHeader} content="Dpt Unit" />
              <Text style={styles.columnHeader} content="Floor" />
              <Text style={styles.columnHeader} content="Ward" />
              <Text style={styles.columnHeader} content="Room No." />
              <Text style={styles.columnHeader} content="Bed No." />
              <Text style={styles.columnHeader} content="Occupy Status" />
            </View>

            {/* Data Rows */}
            {data &&
              data.map((item, index) => {
                return (
                  // For each room, loop over its beds and create a row for each bed
                  item.beds.map((bed, bedIndex) => {
                    totalRecdCash += item.charge; // Assuming charge is the total amount for each bed

                    // Check if the occupy status is "F", to apply neon color
                    const backgroundColor =
                      bed.occupy_status === 'F' ? '#39FF14' : COLORS[(index + bedIndex) % COLORS.length]; // Neon Green for "F"

                    return (
                      <View key={`${index}-${bedIndex}`} style={{ ...styles.row, backgroundColor }}>
                        <Text style={{ ...styles.columnContent, width: '10%' }} content={index + 1} />
                        <Text style={styles.columnContent} content={item.location} />
                        <Text style={styles.columnContent} content={item.nursingstation.name} />
                        <Text style={styles.columnContent} content={item.departmentunit.name} />
                        <Text style={styles.columnContent} content={item.floor.name} />
                        <Text style={styles.columnContent} content={item.wards.name} />
                        <Text style={styles.columnContent} content={item.room_no} />
                        <Text style={styles.columnContent} content={bed.bed_no} />
                        <Text style={styles.columnContent} content={bed.occupy_status} />
                      </View>
                    );
                  })
                );
              })}
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};

export default RoomStatusReportPdf;
